/**
 * Generated from DuckSwapGameLayout.fla
 */
export function DuckSwapGameLayout(this: IDuckSwapGameLayout) {
	const energyBarSegment = this.energyBarSegment;
	if (!energyBarSegment[0] && energyBarSegment.elementFactory) {
		energyBarSegment[0] = energyBarSegment.elementFactory(0,undefined);
	}
	if (energyBarSegment[0]) {
		DuckSwapGameLayout_energyBarSegment0.call(energyBarSegment[0] as IDuckSwapGameLayout_energyBarSegment0);
		energyBarSegment[0].x = 677.55;
		energyBarSegment[0].y = 364.8;
		energyBarSegment[0].width = 29.00;
		energyBarSegment[0].height = 24.50;
		if (energyBarSegment[0].onLayout) energyBarSegment[0].onLayout();
	}
	if (!energyBarSegment[1] && energyBarSegment.elementFactory) {
		energyBarSegment[1] = energyBarSegment.elementFactory(1,undefined);
	}
	if (energyBarSegment[1]) {
		DuckSwapGameLayout_energyBarSegment1.call(energyBarSegment[1] as IDuckSwapGameLayout_energyBarSegment1);
		energyBarSegment[1].x = 708.4;
		energyBarSegment[1].y = 364.3;
		energyBarSegment[1].width = 29.00;
		energyBarSegment[1].height = 24.50;
		if (energyBarSegment[1].onLayout) energyBarSegment[1].onLayout();
	}
	if (!energyBarSegment[2] && energyBarSegment.elementFactory) {
		energyBarSegment[2] = energyBarSegment.elementFactory(2,undefined);
	}
	if (energyBarSegment[2]) {
		DuckSwapGameLayout_energyBarSegment1.call(energyBarSegment[2] as IDuckSwapGameLayout_energyBarSegment1);
		energyBarSegment[2].x = 738.75;
		energyBarSegment[2].y = 364.3;
		energyBarSegment[2].width = 29.00;
		energyBarSegment[2].height = 24.50;
		if (energyBarSegment[2].onLayout) energyBarSegment[2].onLayout();
	}
	if (!energyBarSegment[3] && energyBarSegment.elementFactory) {
		energyBarSegment[3] = energyBarSegment.elementFactory(3,undefined);
	}
	if (energyBarSegment[3]) {
		DuckSwapGameLayout_energyBarSegment3.call(energyBarSegment[3] as IDuckSwapGameLayout_energyBarSegment3);
		energyBarSegment[3].x = 769.1;
		energyBarSegment[3].y = 364.3;
		energyBarSegment[3].width = 29.00;
		energyBarSegment[3].height = 24.50;
		if (energyBarSegment[3].onLayout) energyBarSegment[3].onLayout();
	}
	if (!energyBarSegment[4] && energyBarSegment.elementFactory) {
		energyBarSegment[4] = energyBarSegment.elementFactory(4,undefined);
	}
	if (energyBarSegment[4]) {
		DuckSwapGameLayout_energyBarSegment4.call(energyBarSegment[4] as IDuckSwapGameLayout_energyBarSegment4);
		energyBarSegment[4].x = 799.1;
		energyBarSegment[4].y = 364.8;
		energyBarSegment[4].width = 29.00;
		energyBarSegment[4].height = 24.50;
		if (energyBarSegment[4].onLayout) energyBarSegment[4].onLayout();
	}
	const bg = this.bg;
	DuckSwapGameLayout_bg.call(this.bg);
	bg.x = 512;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const energyBarEmpty = this.energyBarEmpty;
	DuckSwapGameLayout_energyBarEmpty.call(this.energyBarEmpty);
	energyBarEmpty.x = 725.25;
	energyBarEmpty.y = 361.95;
	energyBarEmpty.width = 187.50;
	energyBarEmpty.height = 46.00;
	if (energyBarEmpty.onLayout) energyBarEmpty.onLayout();
	const templateDuck = this.templateDuck;
	DuckSwapGameLayout_templateDuck.call(this.templateDuck);
	templateDuck.x = 720;
	templateDuck.y = 285;
	templateDuck.width = 168.78;
	templateDuck.height = 105.98;
	if (templateDuck.onLayout) templateDuck.onLayout();
	const duckNameBg = this.duckNameBg;
	DuckSwapGameLayout_duckNameBg.call(this.duckNameBg);
	duckNameBg.x = 699.25;
	duckNameBg.y = 294;
	duckNameBg.width = 51.00;
	duckNameBg.height = 27.00;
	if (duckNameBg.onLayout) duckNameBg.onLayout();
	const doneButton = this.doneButton;
	DuckSwapGameLayout_doneButton.call(this.doneButton);
	doneButton.x = 512;
	doneButton.y = 666;
	doneButton.width = 188.00;
	doneButton.height = 114.50;
	if (doneButton.onLayout) doneButton.onLayout();
	return this;
}
function DuckSwapGameLayout_bg(this: IDuckSwapGameLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-duckswap-bg@2x.png", 0.500, 0.500);
	return this;
}
function DuckSwapGameLayout_energyBarEmpty(this: IDuckSwapGameLayout_energyBarEmpty) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-energy-bg.png", 0.501, 0.500);
	return this;
}
function DuckSwapGameLayout_templateDuck(this: IDuckSwapGameLayout_templateDuck) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-duckswap-female-duck.png", 0.501, 0.502);
	return this;
}
function DuckSwapGameLayout_duckNameBg(this: IDuckSwapGameLayout_duckNameBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-duckswap-duckname-container.png", 0.500, 0.500);
	return this;
}
function DuckSwapGameLayout_energyBarSegment0(this: IDuckSwapGameLayout_energyBarSegment0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-energy-red-left.png", 0.500, 0.510);
	return this;
}
function DuckSwapGameLayout_energyBarSegment1(this: IDuckSwapGameLayout_energyBarSegment1) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-energy-yellow-mid.png", 0.517, 0.490);
	return this;
}
function DuckSwapGameLayout_energyBarSegment3(this: IDuckSwapGameLayout_energyBarSegment3) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-energy-green-mid.png", 0.517, 0.490);
	return this;
}
function DuckSwapGameLayout_energyBarSegment4(this: IDuckSwapGameLayout_energyBarSegment4) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-energy-green-right.png", 0.500, 0.510);
	return this;
}
function DuckSwapGameLayout_doneButton(this: IDuckSwapGameLayout_doneButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-btn-done.png", 0.500, 0.500);
	return this;
}
interface IDuckSwapGameLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IDuckSwapGameLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IDuckSwapGameLayoutSprite extends IDuckSwapGameLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IDuckSwapGameLayoutText extends IDuckSwapGameLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IDuckSwapGameLayoutPolygon extends Array<number> {
}
interface IDuckSwapGameLayout {
	readonly energyBarSegment: IDuckSwapGameLayoutArray<IDuckSwapGameLayout_energyBarSegment0|IDuckSwapGameLayout_energyBarSegment1|IDuckSwapGameLayout_energyBarSegment3|IDuckSwapGameLayout_energyBarSegment4>;
	readonly bg: IDuckSwapGameLayout_bg;
	readonly energyBarEmpty: IDuckSwapGameLayout_energyBarEmpty;
	readonly templateDuck: IDuckSwapGameLayout_templateDuck;
	readonly duckNameBg: IDuckSwapGameLayout_duckNameBg;
	readonly doneButton: IDuckSwapGameLayout_doneButton;
}
interface IDuckSwapGameLayout_bg extends IDuckSwapGameLayoutSprite {
}
interface IDuckSwapGameLayout_energyBarEmpty extends IDuckSwapGameLayoutSprite {
}
interface IDuckSwapGameLayout_templateDuck extends IDuckSwapGameLayoutSprite {
}
interface IDuckSwapGameLayout_duckNameBg extends IDuckSwapGameLayoutSprite {
}
interface IDuckSwapGameLayout_energyBarSegment0 extends IDuckSwapGameLayoutSprite {
}
interface IDuckSwapGameLayout_energyBarSegment1 extends IDuckSwapGameLayoutSprite {
}
interface IDuckSwapGameLayout_energyBarSegment3 extends IDuckSwapGameLayoutSprite {
}
interface IDuckSwapGameLayout_energyBarSegment4 extends IDuckSwapGameLayoutSprite {
}
interface IDuckSwapGameLayout_doneButton extends IDuckSwapGameLayoutSprite {
}
